import styled, { css } from 'styled-components';
import { Popover } from '../popover';
import { Subtitle2 } from '../typography';
import { Z_INDEXES } from '../../../src/styled/global-variables';
import { getElevation, getThemeProp, getColor, getColorShade, getSizeBy } from '../../../src/styled/utils';
const tooltipWrapperTextCSS = css `
  color: ${({ $isWhite }) => getColor($isWhite ? 'onBackground' : 'surface')};
  text-align: center;
  word-break: break-word;
`;
export const StyledArrow = styled.span `
  width: var(--tooltip-arrow-size);
  height: var(--tooltip-arrow-size);

  &::before {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border: calc(var(--tooltip-arrow-size) / 2) solid;
    border-color: ${({ $isWhite }) => getColor($isWhite ? 'surface' : 'onSurface')};
    box-shadow: ${getElevation(16)};
    transform: rotate(calc(-45deg + 90deg * var(--arrow-rotation-position)));
    transform-origin: center center;
    content: '';
  }
`;
export const TooltipWrapper = styled(Popover) `
  --tooltip-arrow-size: ${({ theme }) => theme.sizeUnit * 1.5}px;
  --arrow-rotation-position: 0;
  --tooltip-offset: 6px;

  position: fixed;
  z-index: ${Z_INDEXES.OVERLAY};
  max-width: 250px;
  padding: ${getSizeBy(2)} ${getSizeBy(3)};
  background-color: ${({ $isWhite }) => getColor($isWhite ? 'surface' : 'onSurface')};
  border: ${({ $isWhite, theme }) => $isWhite && `1px solid ${getColorShade('onSurface', 'outline')({ theme })}`};
  border-radius: ${getThemeProp('borderRadius')}px;
  box-shadow: ${getElevation(16)};

  & > ${Subtitle2} {
    ${({ $isString }) => $isString && tooltipWrapperTextCSS};
  }

  /*  
   invisible connector between the element and the tooltip
   so that the cursor can move to the tooltip without losing focus
   so that we can interact with content in tooltip  
*/
  &::before {
    position: absolute;
    display: block;
    width: calc(var(--tooltip-offset) + 1px);
    height: 100%;
    content: '';
  }

  &[data-popper-placement*='bottom']::before,
  &[data-popper-placement*='top']::before {
    width: 100%;
    height: calc(var(--tooltip-offset) + 1px);
  }

  &[data-popper-placement*='bottom']::before {
    top: 0;
    left: 0;
    transform: translateY(-100%);
  }

  &[data-popper-placement*='left']::before {
    top: 0;
    right: 0;
    transform: translateX(100%);
  }

  &[data-popper-placement*='right']::before {
    top: 0;
    left: 0;
    transform: translateX(-100%);
  }

  &[data-popper-placement*='top']::before {
    bottom: 0;
    left: 0;
    transform: translateY(100%);
  }

  /* end of connector trick */

  &[data-popper-placement*='bottom'] > ${StyledArrow} {
    top: calc(0.5px + var(--tooltip-arrow-size) * -1 / 2);
  }

  &[data-popper-placement*='top'] > ${StyledArrow} {
    --arrow-rotation-position: 2;

    bottom: calc(0.5px + var(--tooltip-arrow-size) * -1 / 2);
  }

  &[data-popper-placement*='left'] > ${StyledArrow} {
    --arrow-rotation-position: 1;

    right: calc(0.5px + var(--tooltip-arrow-size) * -1 / 2);
  }

  &[data-popper-placement*='right'] > ${StyledArrow} {
    --arrow-rotation-position: 3;

    left: calc(0.5px + var(--tooltip-arrow-size) * -1 / 2);
  }
`;
